export default __webpack_public_path__ + "static/about-us-richard-a923f0d2ddefda919b82bd918dec07f3.webp";